import { getUID } from '@redviking/argonaut-util/src/getUID';
import { getAllAppletVariables } from '@redviking/argonaut-util/src/mes/appletUtil';
import type { UiNodeSpec } from './UiNodeSpec';
import { createNodeSocket } from '../../sync-utils/create-node-socket';
import { accessor } from 'src/store';
import type { NodeCfg } from '@redviking/argonaut-util/types/mes/applet-designs/flow.latest';
import { getSocketTypeForVarId } from '../socket-var-helpers';

export const varWriteUiNodeSpec: UiNodeSpec<'varWrite'> = {
    requiredSockets: [ 'trigger' ],
    cfg: () => ({ controlValues: { varId: '' }, id: getUID(), kind: 'varWrite', disabled: false }),
    controls: getNodeCfg => ({
        varId: {
            cfg: {
                kind: 'selectVar',
                onSelect: val => {
                    const nodeCfg = getNodeCfg();
                    const controlValues: NodeCfg<'varWrite'>['controlValues'] = {
                        ...nodeCfg.controlValues,
                        varId: val,
                    };
                    const newNodeCfg = {
                        ...nodeCfg,
                        controlValues,
                    };
                    createNodeSocket({
                        newNodeCfg,
                    });
                },
            },
            nodeCfg: getNodeCfg(),
            value: getNodeCfg().controlValues.varId,
        },
    }),
    inputs: nodeCfg => {
        const varDataType = accessor.appletDesign.allAppletVariables[nodeCfg.controlValues.varId]?.type;
        
        return {
            trigger: { socket: 'event', label: 'Trigger' },
            value: {
                control: {
                    cfg: { kind: 'varValue', nullable: true, label: 'Value', dataType: varDataType && varDataType !== 'empty' ? varDataType : undefined },
                    nullable: true,
                    nodeCfg,
                    value: nodeCfg.socketDefaults?.inputs?.value,
                },
                socket: getSocketTypeForVarId(nodeCfg.controlValues.varId),
            },
        };
    },
    kindLabel: 'Variable Write',
    nodeCategory: 'variable',
    outputs: () => ({ next: { socket: 'event', label: 'Next' } }),
    validator: (node, appletDesignVersionConfig) => {
        const errors: Record<string, string> = {};
        if (!node.controlValues.varId) {
            errors.varId = 'Variable is required';
        }
        const allAppletVariables = getAllAppletVariables(appletDesignVersionConfig);
        if (!allAppletVariables[node.controlValues.varId]) {
            errors.varId = 'Variable is not a valid variable';
        }
        return Object.keys(errors).length ? errors : true;
    },
};
